import React, { useState, useRef, useCallback, useEffect } from 'react';
import * as Icons from 'react-feather';
import { toast } from 'react-toastify';
import Skeleton from 'react-loading-skeleton';
import { Api } from '../../../../services/Api';

var ACCEPTED_TYPES = ['application/pdf', 'image/jpeg', 'image/png', 'image/webp'];
var MAX_FILE_SIZE = 100 * 1024 * 1024; // 100 Mo
var ITEMS_PER_PAGE = 20;

// TODO: Remplacer par les vrais endpoints API
var UPLOAD_ENDPOINT = 'formalite/lotissement/insert/';
var LIST_ENDPOINT = 'formalite/lotissement/';

var LotissementList = function() {
    var _useState1 = useState([]);
    var attributions = _useState1[0];
    var setAttributions = _useState1[1];

    var _useState2 = useState(0);
    var totalCount = _useState2[0];
    var setTotalCount = _useState2[1];

    var _useState3 = useState(null);
    var nextPageUrl = _useState3[0];
    var setNextPageUrl = _useState3[1];

    var _useState4 = useState(null);
    var previousPageUrl = _useState4[0];
    var setPreviousPageUrl = _useState4[1];

    var _useState5 = useState(1);
    var page = _useState5[0];
    var setPage = _useState5[1];

    var _useState6 = useState(true);
    var loading = _useState6[0];
    var setLoading = _useState6[1];

    var _useState7 = useState(false);
    var isDragOver = _useState7[0];
    var setIsDragOver = _useState7[1];

    var _useState8 = useState(false);
    var uploading = _useState8[0];
    var setUploading = _useState8[1];

    var _useState9 = useState(null);
    var selectedAttribution = _useState9[0];
    var setSelectedAttribution = _useState9[1];

    var fileInputRef = useRef(null);

    var totalPages = Math.ceil(totalCount / ITEMS_PER_PAGE);

    var fetchAttributions = useCallback(async function(endpoint) {
        setLoading(true);
        try {
            var url = endpoint || LIST_ENDPOINT;
            var response = await Api.get(url);
            setAttributions(response.results || []);
            setTotalCount(response.count || 0);
            setNextPageUrl(response.next || null);
            setPreviousPageUrl(response.previous || null);
        } catch (error) {
            console.error('Erreur lors du chargement des attributions:', error);
            toast.error("Erreur lors du chargement des attributions");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(function() {
        fetchAttributions();
    }, [fetchAttributions]);

    var handlePageChange = function(url, newPage) {
        if (!url) return;
        var path = url.replace(/^https?:\/\/[^/]+\//, '');
        setPage(newPage);
        fetchAttributions(path);
    };

    var validateFile = function(file) {
        if (!ACCEPTED_TYPES.includes(file.type)) {
            return 'Format non accepté : ' + file.name;
        }
        if (file.size > MAX_FILE_SIZE) {
            return 'Fichier trop volumineux : ' + file.name + ' (max 100 Mo)';
        }
        return null;
    };

    var handleFiles = useCallback(async function(files) {
        var validFiles = [];
        var errors = [];

        for (var i = 0; i < files.length; i++) {
            var error = validateFile(files[i]);
            if (error) {
                errors.push(error);
            } else {
                validFiles.push(files[i]);
            }
        }

        if (errors.length > 0) {
            toast.error(errors.join('\n'));
        }

        if (validFiles.length === 0) return;

        setUploading(true);

        try {
            var formData = new FormData();
            for (var j = 0; j < validFiles.length; j++) {
                formData.append('fichiers', validFiles[j]);
            }

            var response = await Api.postFormData(UPLOAD_ENDPOINT, formData);

            toast.success(response.message || "Attribution(s) extraite(s) avec succès");
            setPage(1);
            await fetchAttributions();
        } catch (err) {
            console.error('Erreur lors du téléversement:', err);
            toast.error("Erreur lors du téléversement des fichiers");
        } finally {
            setUploading(false);
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
        }
    }, [fetchAttributions]);

    var handleDragOver = function(e) {
        e.preventDefault();
        setIsDragOver(true);
    };

    var handleDragLeave = function(e) {
        e.preventDefault();
        setIsDragOver(false);
    };

    var handleDrop = function(e) {
        e.preventDefault();
        setIsDragOver(false);
        handleFiles(e.dataTransfer.files);
    };

    var handleFileSelect = function(e) {
        if (e.target.files.length > 0) {
            handleFiles(e.target.files);
        }
    };

    var handleClickUpload = function() {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    return (
        <div style={{ padding: '24px', maxWidth: '1400px', margin: '0 auto' }}>
            {/* En-tête */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                marginBottom: '24px',
                backgroundColor: '#FFF7ED',
                borderRadius: '12px',
                padding: '24px'
            }}>
                <div style={{
                    width: '56px',
                    height: '56px',
                    backgroundColor: '#F97316',
                    borderRadius: '12px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                }}>
                    <Icons.MapPin size={28} color="white" />
                </div>
                <div>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#F97316',
                        margin: 0
                    }}>
                        Lotissement
                    </h1>
                    <p style={{
                        fontSize: '14px',
                        color: '#6B7280',
                        margin: '4px 0 0 0'
                    }}>
                        Téléversez des PDF d'annonces d'attribution de titre foncier pour extraction automatique via OCR
                    </p>
                </div>
            </div>

            {/* Zone de téléversement */}
            <div style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '24px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    marginBottom: '20px'
                }}>
                    <Icons.Upload size={20} color="#F97316" />
                    <h2 style={{
                        fontSize: '18px',
                        fontWeight: '600',
                        color: '#1F2937',
                        margin: 0
                    }}>
                        Zone de téléversement
                    </h2>
                </div>

                <div
                    onClick={handleClickUpload}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                    style={{
                        border: '2px dashed ' + (isDragOver ? '#F97316' : '#FDBA74'),
                        borderRadius: '12px',
                        padding: '48px 24px',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        backgroundColor: isDragOver ? '#FFF7ED' : '#FFFBF5',
                        transition: 'all 0.2s ease'
                    }}
                >
                    {uploading ? (
                        <React.Fragment>
                            <div style={{
                                width: '56px',
                                height: '56px',
                                borderRadius: '50%',
                                backgroundColor: '#FFF7ED',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '16px',
                                animation: 'lotissement-pulse 1.5s infinite'
                            }}>
                                <Icons.Loader size={28} color="#F97316" style={{ animation: 'lotissement-spin 1s linear infinite' }} />
                            </div>
                            <p style={{ fontSize: '16px', fontWeight: '500', color: '#374151', margin: 0 }}>
                                Traitement en cours...
                            </p>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <div style={{
                                width: '56px',
                                height: '56px',
                                borderRadius: '50%',
                                backgroundColor: '#FFF7ED',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '16px'
                            }}>
                                <Icons.Upload size={28} color="#F97316" />
                            </div>
                            <p style={{
                                fontSize: '16px',
                                fontWeight: '500',
                                color: '#374151',
                                margin: '0 0 8px 0'
                            }}>
                                Glissez vos fichiers ici ou cliquez pour sélectionner
                            </p>
                            <p style={{
                                fontSize: '13px',
                                color: '#9CA3AF',
                                margin: 0
                            }}>
                                Formats acceptés : PDF, JPG, PNG, WEBP - Taille max : 100 Mo
                            </p>
                        </React.Fragment>
                    )}
                </div>

                <input
                    ref={fileInputRef}
                    type="file"
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png,.webp"
                    onChange={handleFileSelect}
                    style={{ display: 'none' }}
                />
            </div>

            {/* Tableau des attributions extraites */}
            <div style={{
                backgroundColor: 'white',
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
            }}>
                {/* En-tête du tableau */}
                <div style={{
                    backgroundColor: '#FFF7ED',
                    padding: '20px 24px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px'
                }}>
                    <div style={{
                        width: '40px',
                        height: '40px',
                        backgroundColor: '#FDBA74',
                        borderRadius: '10px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0
                    }}>
                        <Icons.MapPin size={20} color="white" />
                    </div>
                    <div>
                        <h2 style={{
                            fontSize: '18px',
                            fontWeight: '600',
                            color: '#1F2937',
                            margin: 0
                        }}>
                            Attributions de Titres Fonciers Extraites
                        </h2>
                        <p style={{
                            fontSize: '13px',
                            color: '#6B7280',
                            margin: '2px 0 0 0'
                        }}>
                            {totalCount} attribution{totalCount !== 1 ? 's' : ''} extraite{totalCount !== 1 ? 's' : ''}
                        </p>
                    </div>
                </div>

                {/* Table */}
                <div style={{ overflowX: 'auto' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr style={{ backgroundColor: '#FFF7ED' }}>
                                <th style={thStyle}>Lot</th>
                                <th style={thStyle}>Îlot</th>
                                <th style={thStyle}>Lotissement</th>
                                <th style={thStyle}>Commune</th>
                                <th style={thStyle}>Superficie (m²)</th>
                                <th style={thStyle}>Propriétaire</th>
                                <th style={thStyle}>Titre Foncier</th>
                                <th style={thStyle}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="8" style={{ padding: '16px' }}>
                                        <Skeleton count={5} height={32} style={{ marginBottom: '8px' }} />
                                    </td>
                                </tr>
                            ) : attributions.length === 0 ? (
                                <tr>
                                    <td colSpan="8" style={{ padding: '60px 24px', textAlign: 'center' }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '12px'
                                        }}>
                                            <div style={{
                                                width: '56px',
                                                height: '56px',
                                                borderRadius: '50%',
                                                backgroundColor: '#F3F4F6',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <Icons.MapPin size={28} color="#9CA3AF" />
                                            </div>
                                            <p style={{
                                                fontSize: '16px',
                                                fontWeight: '500',
                                                color: '#6B7280',
                                                margin: 0
                                            }}>
                                                Aucune attribution extraite pour le moment. Téléversez un PDF pour commencer.
                                            </p>
                                        </div>
                                    </td>
                                </tr>
                            ) : (
                                attributions.map(function(attr) {
                                    return (
                                        <tr key={attr.id} style={{ borderBottom: '1px solid #F3F4F6' }}>
                                            <td style={tdStyle}>{attr.lot || '-'}</td>
                                            <td style={tdStyle}>{attr.ilot || '-'}</td>
                                            <td style={{ ...tdStyle, fontWeight: '500' }}>{attr.lotissement || '-'}</td>
                                            <td style={tdStyle}>{attr.commune || '-'}</td>
                                            <td style={tdStyle}>
                                                {attr.superficie != null ? Number(attr.superficie).toLocaleString('fr-FR') : '-'}
                                            </td>
                                            <td style={{ ...tdStyle, maxWidth: '200px' }}>
                                                <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={attr.proprietaire}>
                                                    {attr.proprietaire || '-'}
                                                </div>
                                            </td>
                                            <td style={{ ...tdStyle, fontWeight: '500' }}>{attr.titre_foncier || '-'}</td>
                                            <td style={tdStyle}>
                                                <button
                                                    onClick={function() { setSelectedAttribution(attr); }}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '4px',
                                                        padding: '6px 12px',
                                                        borderRadius: '6px',
                                                        border: '1px solid #F97316',
                                                        backgroundColor: 'white',
                                                        color: '#F97316',
                                                        cursor: 'pointer',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        whiteSpace: 'nowrap'
                                                    }}
                                                >
                                                    <Icons.Eye size={14} />
                                                    Voir
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        padding: '16px 24px',
                        borderTop: '1px solid #F3F4F6'
                    }}>
                        <p style={{ fontSize: '13px', color: '#6B7280', margin: 0 }}>
                            Page {page} sur {totalPages} ({totalCount} résultats)
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <button
                                onClick={function() { handlePageChange(previousPageUrl, page - 1); }}
                                disabled={!previousPageUrl || loading}
                                style={paginationBtnStyle(!previousPageUrl)}
                            >
                                <Icons.ChevronLeft size={16} />
                                Précédent
                            </button>
                            <div style={{
                                padding: '8px 16px',
                                borderRadius: '8px',
                                backgroundColor: '#F97316',
                                color: 'white',
                                fontSize: '14px',
                                fontWeight: '600',
                                minWidth: '40px',
                                textAlign: 'center'
                            }}>
                                {page}
                            </div>
                            <button
                                onClick={function() { handlePageChange(nextPageUrl, page + 1); }}
                                disabled={!nextPageUrl || loading}
                                style={paginationBtnStyle(!nextPageUrl)}
                            >
                                Suivant
                                <Icons.ChevronRight size={16} />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {/* Modal détail attribution */}
            {selectedAttribution && (
                <div
                    onClick={function(e) { if (e.target === e.currentTarget) setSelectedAttribution(null); }}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 9999,
                        padding: '24px'
                    }}
                >
                    <div style={{
                        backgroundColor: '#F9FAFB',
                        borderRadius: '16px',
                        width: '100%',
                        maxWidth: '680px',
                        maxHeight: '90vh',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0 25px 50px rgba(0,0,0,0.25)'
                    }}>
                        {/* Header orange */}
                        <div style={{
                            background: 'linear-gradient(135deg, #F97316, #EA580C)',
                            padding: '24px',
                            position: 'relative'
                        }}>
                            <button
                                onClick={function() { setSelectedAttribution(null); }}
                                style={{
                                    position: 'absolute',
                                    top: '16px',
                                    right: '16px',
                                    width: '32px',
                                    height: '32px',
                                    borderRadius: '50%',
                                    border: '2px solid white',
                                    backgroundColor: 'transparent',
                                    color: 'white',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <Icons.X size={16} />
                            </button>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                                <Icons.MapPin size={20} color="white" />
                                <span style={{
                                    padding: '4px 14px',
                                    borderRadius: '20px',
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    backgroundColor: 'rgba(255,255,255,0.2)',
                                    color: 'white',
                                    textTransform: 'uppercase'
                                }}>
                                    Attribution de Titre Foncier
                                </span>
                            </div>
                            <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: 'white', lineHeight: '1.4' }}>
                                {selectedAttribution.lotissement ? 'Lotissement ' + selectedAttribution.lotissement : 'Détail de l\'attribution'}
                            </h3>
                            {selectedAttribution.commune && (
                                <p style={{ margin: '6px 0 0 0', fontSize: '14px', color: 'rgba(255,255,255,0.85)' }}>
                                    {selectedAttribution.commune}
                                </p>
                            )}
                        </div>

                        {/* Body scrollable */}
                        <div style={{ padding: '24px', overflowY: 'auto', flex: 1 }}>
                            {/* Identification parcelle */}
                            <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #E5E7EB', padding: '20px', marginBottom: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px', fontSize: '14px', fontWeight: '600', color: '#374151' }}>
                                    <Icons.Grid size={16} color="#F97316" />
                                    Identification de la parcelle
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                                    <div style={{ borderLeft: '3px solid #F97316', paddingLeft: '12px' }}>
                                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#F97316', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Lot</p>
                                        <p style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', margin: 0 }}>{selectedAttribution.lot || '-'}</p>
                                    </div>
                                    <div style={{ borderLeft: '3px solid #EAB308', paddingLeft: '12px' }}>
                                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#EAB308', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Îlot</p>
                                        <p style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', margin: 0 }}>{selectedAttribution.ilot || '-'}</p>
                                    </div>
                                    <div style={{ borderLeft: '3px solid #E5E7EB', paddingLeft: '12px' }}>
                                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Superficie</p>
                                        <p style={{ fontSize: '16px', fontWeight: '700', color: '#1F2937', margin: 0 }}>
                                            {selectedAttribution.superficie != null ? Number(selectedAttribution.superficie).toLocaleString('fr-FR') + ' m²' : '-'}
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div style={{ borderLeft: '3px solid #F97316', paddingLeft: '12px' }}>
                                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#F97316', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Lotissement</p>
                                        <p style={{ fontSize: '15px', fontWeight: '600', color: '#1F2937', margin: 0 }}>{selectedAttribution.lotissement || '-'}</p>
                                    </div>
                                    <div style={{ borderLeft: '3px solid #E5E7EB', paddingLeft: '12px' }}>
                                        <p style={{ fontSize: '11px', fontWeight: '600', color: '#6B7280', margin: '0 0 2px 0', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Commune</p>
                                        <p style={{ fontSize: '15px', fontWeight: '600', color: '#1F2937', margin: 0 }}>{selectedAttribution.commune || '-'}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Propriétaire */}
                            <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #E5E7EB', padding: '20px', marginBottom: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontSize: '11px', fontWeight: '600', color: '#F97316', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    <Icons.User size={14} color="#F97316" />
                                    Propriétaire
                                </div>
                                <p style={{ fontSize: '15px', fontWeight: '600', color: '#1F2937', margin: 0, lineHeight: '1.6' }}>{selectedAttribution.proprietaire || '-'}</p>
                            </div>

                            {/* Titre Foncier */}
                            <div style={{ backgroundColor: 'white', borderRadius: '12px', border: '1px solid #E5E7EB', padding: '20px', marginBottom: '16px' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '8px', fontSize: '11px', fontWeight: '600', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    <Icons.FileText size={14} color="#6B7280" />
                                    Titre Foncier
                                </div>
                                <p style={{ fontSize: '15px', fontWeight: '600', color: '#1F2937', margin: 0 }}>{selectedAttribution.titre_foncier || '-'}</p>
                            </div>

                            {/* Contenu complet */}
                            {selectedAttribution.contenu_complet && (
                                <div style={{ marginBottom: '16px' }}>
                                    <div style={{
                                        backgroundColor: '#F97316',
                                        borderRadius: '10px 10px 0 0',
                                        padding: '14px 20px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    }}>
                                        <Icons.FileText size={16} color="white" />
                                        <span style={{ fontSize: '13px', fontWeight: '700', color: 'white', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Contenu complet</span>
                                    </div>
                                    <div style={{
                                        backgroundColor: 'white',
                                        border: '1px solid #E5E7EB',
                                        borderTop: 'none',
                                        borderRadius: '0 0 10px 10px',
                                        padding: '20px',
                                        borderLeft: '3px solid #F97316'
                                    }}>
                                        <p style={{ fontSize: '14px', color: '#374151', margin: 0, lineHeight: '1.7', whiteSpace: 'pre-wrap' }}>{selectedAttribution.contenu_complet}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Footer modal */}
                        <div style={{
                            padding: '16px 24px',
                            borderTop: '1px solid #E5E7EB',
                            backgroundColor: 'white',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}>
                            <span style={{ fontSize: '13px', color: '#F97316' }}>
                                {"Réf: " + (selectedAttribution.id ? String(selectedAttribution.id).substring(0, 8) : '-')}
                            </span>
                            <button
                                onClick={function() { setSelectedAttribution(null); }}
                                style={{
                                    padding: '8px 24px',
                                    borderRadius: '8px',
                                    border: '1px solid #E5E7EB',
                                    backgroundColor: '#F9FAFB',
                                    color: '#374151',
                                    cursor: 'pointer',
                                    fontSize: '14px',
                                    fontWeight: '500'
                                }}
                            >
                                Fermer
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/* Animation CSS */}
            <style dangerouslySetInnerHTML={{ __html: "@keyframes lotissement-spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } @keyframes lotissement-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.5; } }" }} />
        </div>
    );
};

var thStyle = {
    padding: '12px 16px',
    textAlign: 'left',
    fontSize: '13px',
    fontWeight: '600',
    color: '#374151',
    borderBottom: '1px solid #FDE8CD'
};

var tdStyle = {
    padding: '12px 16px',
    fontSize: '14px',
    color: '#374151'
};

function paginationBtnStyle(disabled) {
    return {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        padding: '8px 16px',
        borderRadius: '8px',
        border: '1px solid #E5E7EB',
        backgroundColor: disabled ? '#F9FAFB' : 'white',
        color: disabled ? '#D1D5DB' : '#374151',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        fontWeight: '500'
    };
}

export default LotissementList;
